<template>
  <div class="page-login">
    <div class="bg"></div>

    <div class="main">
      <div style="flex: 0 0 80px; background-color: #151A28;">
        <div style="max-width: 1180px; margin: auto; line-height: 80px; color: #fff;">
          <span style="font-size: 22px">
            <i
              class="iconfont icon-mobanJiguanglogo"
              style="font-size:22px"
            ></i>
            财政电子票据管理平台2</span>
        </div>
      </div>
      <div style="flex: 1; overflow: hidden; position: relative">
        <el-carousel
          class="bgi-wrap"
          :height="view.mh"
        >
          <el-carousel-item>
            <div class="bgil1">
              <div class="bgil2">
                <img
                  class="bgi"
                  src="../../assets/img/index/index-1.png"
                />
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="bgil1">
              <div class="bgil2">
                <img
                  class="bgi"
                  src="../../assets/img/index/index-2.png"
                />
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="bgil1">
              <div class="bgil2">
                <img
                  class="bgi"
                  src="../../assets/img/index/index-3.png"
                />
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

        <div class="lf">
          <div class="lf-bg"></div>
          <div class="lf-fg">
            <div class="lf-tr">
              <div
                class="lf-tr-01"
                v-show="view.sf"
                @click="qh()"
              ></div>
              <div
                class="lf-tr-02"
                v-show="!view.sf"
                @click="qh()"
              ></div>
            </div>

            <!-- form -->
            <div
              v-show="view.sf"
              class="lf-f"
            >

              <div class="lf-f-t">手机登录</div>
              <el-form
                ref="form"
                :model="form"
                label-width="100px"
              >
                <el-form-item label="用户名：">
                  <el-input
                    v-model="form.name"
                    placeholder="注册用户手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机验证码：">
                  <!-- type="password"-->
                  <el-input
                    v-model="form.password"
                    class="elipt-yzm"
                    placeholder="登录验证码"
                  ></el-input>
                  <el-button
                    :disabled="yzm.y"
                    type="primary"
                    class="btn-yzm"
                    @click="fsyzm"
                  >{{yzm.text}}</el-button>
                </el-form-item>
                <el-form-item>
                </el-form-item>
                <div style="text-align: center;">

                  <el-button
                    type="primary"
                    @click="yzmdl"
                  >登录</el-button>
                </div>
              </el-form>
            </div>

            <!-- 扫码 -->
            <div
              v-show="!view.sf"
              class="lf-i "
            >
              <div class="lf-i-t">扫码登录</div>
              <div
                style="text-align: center;"
                v-show="view.is == '1' || view.is == '2'"
              >
                <div
                  v-loading="view.il"
                  style="width: 220px; 
                    height:280px;
                    margin:auto; 
                    position:relative;"
                >
                  <img
                    v-show="view.is == '1'"
                    id="img_ewm"
                    style="width: 100%;"
                  />

                  <div
                    v-show="view.is == '2'"
                    id="div_sx"
                    style="
                       text-align: center;
                       background: #fff;"
                    @click="clickSx"
                  >
                    <div style="font-size: 32px;margin: 16px;">
                      <i class="el-icon-refresh-right"></i>
                    </div>
                    <div>二维码失效,点击刷新</div>
                  </div>
                </div><!-- /div_sx -->
              </div><!-- /div_img -->

              <!-- 1 -->
              <div
                v-show="view.is == '3'"
                style="width: 220px; 
                    height:220px;
                    margin:auto;
                    padding-top: 40px;
                    background: #fff;"
              >
                <div>
                  <i
                    class="el-icon-success"
                    style="font-size: 90px;color: #51bd82;"
                  ></i>
                </div>
                <div>
                  扫码成功
                </div>
              </div>
              <!-- 2 -->
              <div
                v-show="view.is == '4'"
                style="width: 220px; 
                    height:220px;
                    margin:auto;
                    padding-top: 40px;
                    background-color: #fff;"
              >
                <div>
                  <i
                    class="el-icon-success"
                    style="font-size: 90px;color: #51bd82;"
                  ></i>
                </div>

                <div style="margin:8px;">
                  您暂无权限登录，进行单位入驻操作或联系管理员处理
                </div>
                <div>
                  <el-button
                    id="btn_rz"
                    type="primary"
                    @click="clickRz"
                  >单位入驻</el-button>
                </div>
                <div>
                  <a
                    href="javascript:void(0)"
                    style=""
                    @click="clickSx"
                  >重新获取二维码</a>
                </div>
              </div>

              <!-- 3 -->
              <div
                v-show="view.is == '5'"
                style="width: 220px; 
                    height:220px;
                    margin:auto;
                    padding: 12px;
                    padding-top: 30px;
                    background: #fff;"
              >
                <div style="margin:18px;">
                  <i
                    class="el-icon-error"
                    style="
                        font-size: 90px;
                        color: #E83B38;"
                  ></i>
                </div>
                <div>
                  您没有使用权限，请联系管理员
                </div>
              </div>
            </div>
            <!-- /扫码 -->
          </div>
        </div>
      </div>

      <div class="footer">
        <div style="text-align: center; ">
          <p>
            <span>瑞宏网 中国领先电子发票平台 东港股份有限公司&copy;版权所有</span>
            <span style="display: inline-block; margin:auto 8px">|</span>
            <span>技术支持:北京东港瑞宏科技有限公司</span>
          </p>
          <p>建议您使用Chrome、360等主流浏览器访问本系统</p>
        </div>
      </div>
    </div>
    <script
      id="tpl_json"
      type="template/text"
    >
    </script>
  </div>
</template>
<script>
let _ajax_loop_able = true;
let _ajax_loop_count = 0;

let _ajax_sx = true;
let prefix = "";

let _yzm_loop = false;
const w = {
  data() {
    const data = {
      view: {
        mh: "600px",
        sf: false,
        si: true,
        il: true,
        lftr: "p",
        is: "1",
      },
      imgLoading: true,
      key: "",
      token: "",
      form: {
        name: "",
        password: "",
      },
      yzm: {
        y: false,
        text: "发送验证码",
      },
    };
    return data;
  },
  methods: {
    ajaxGetImg() {
      this.$axios
        .post(prefix + "/api?jkDm=GETQRCODEBASE64", { t: 1 })
        .then((response) => {
          console.log(response.data.returnCode, response.data);
          if (response.data.returnCode == "0000") {
            //let src = "data:image/png;base64," + response.data.data.qrcode;
            document.getElementById("img_ewm").src = response.data.data.qrcode;
            this.key = response.data.data.key;
            //console.log('---------------------------------------------------------------')
            //console.log('this.key',this.key)
            this.view.il = false;
            _ajax_loop_count = 0;
            this.ajaxLoop();
          }
        });
    },
    clickSx() {
      this.view.is = "1";
      this.view.il = true;
      this.ajaxGetImg();
    },

    noLoop() {
      this.view.is = "2";
    },

    ajaxLoop() {
      if (!_ajax_loop_able) {
        return;
      }

      if (_ajax_loop_count >= 60 * 5) {
        this.noLoop();
        return;
      }
      _ajax_loop_count++;

      let data = { key: this.key };
      console.log("data", data);
      setTimeout(() => {
        this.$axios
          .post(prefix + "/api?jkDm=CHECKQRCODESCAN", data)
          .then((response) => {
            console.log(response.data.returnCode, response.data);
            if (response.data.returnCode == "0000") {
              // -1 超时未扫描
              // 0未扫码
              // 1 已扫码
              // 2  可以登录
              // 3  没有用户

              switch (response.data.data.flag) {
                case "0":
                  this.ajaxLoop();
                  break;
                case "-1":
                  this.noLoop();
                  break;
                case "1":
                  this.view.is = "3";
                  this.ajaxLoop();
                  break;
                case "2":
                  this.handleF2(response.data.data);
                  break;
                case "3":
                  this.handleF3(response.data);
                  break;
                case "4":
                  this.handleF4(response.data.data);
                  break;
              }
            } else if (response.data.returnCode == "1113") {
              //二维码已超时，请刷新
              this.noLoop();
            }
          });
      }, 1000);
    },

    handleF1() {
      this.view.is = "3";
    },
    handleF2(data) {
      // 2  可以登录
      _ajax_loop_able = false;
      sessionStorage.setItem("token", data.token);
      this.$router.push("/index");
      //window["userName"] = data.userName;
      sessionStorage.setItem("userName", data.userName);
    },
    clickRz() {
      _ajax_loop_able = false;
      sessionStorage.setItem("token", this.token);
      this.$router.push("/enter/01");
    },
    handleF3(data) {
      _ajax_loop_able = false;
      this.$message.error(data.returnMsg);
    },
    handleF4(data) {
      _ajax_loop_able = false;
      sessionStorage.setItem("token", data.token);
      this.$router.push("/index");
    },
    onSubmit() {},
    initHeight() {
      let height = window.innerHeight - 83 - 91 + 2;
      this.view.mh = height + "px";
    },

    qh() {
      if (this.view.sf) {
        this.view.sf = false;
        this.view.il = true;
        _ajax_loop_able = true;
        this.ajaxGetImg();
      } else {
        this.view.sf = true;
        _ajax_loop_able = false;
      }
    },

    getType() {
      let h = window.location.hash;
      let index = h.indexOf("?");
      if (index == -1) {
        return "";
      }

      let qt = h.substring(index + 1);
      let variable = "type";
      var vars = qt.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return "";
    },
    fsyzm() {
      let data = {
        sjhm: this.form.name,
      };
      let cr = ((body) => {
        if (!body.sjhm || !body.sjhm.trim()) {
          return "手机号不能为空";
        }

        if (body.sjhm.trim().length != 11 || body.sjhm.trim()[0] != "1") {
          return "手机号码格式有误";
        }
        return "";
      })(data);

      if (cr) {
        this.$message.error(cr);
        return;
      }

      console.log(data);
      this.$axios.post(prefix + "/api?jkDm=GETYZM", data).then((resonpse) => {
        console.log(resonpse, resonpse.data);
        if (resonpse.data.returnCode != "0000") {
          this.$message.error(resonpse.data.returnMsg);
          return;
        }
        this.yzm.y = true;
        this.yzm.text = "发送成功";
        this.$message.success("验证码短信已发送,请稍后查看手机短信");
      });
    },
    yzmdl() {
      let data = {
        sjhm: this.form.name,
        yzm: this.form.password,
      };
      console.log(data);
      this.$axios.post(prefix + "/api?jkDm=LOGINYZM", data).then((resonpse) => {
        console.log(resonpse.data);
        if (resonpse.data.returnCode != "0000") {
          this.$message.error(resonpse.data.returnMsg);
          return;
        }

        sessionStorage.setItem("token", resonpse.data.data.token);
        sessionStorage.setItem("userName", resonpse.data.data.userName);
        this.$router.push("/index");
      });
    },
  },
  mounted() {
    this.initHeight();
    sessionStorage.clear();

    //*
    let type = this.getType();
    console.log(type);
    if (type) {
      this.view.il = false;
      this.view.is = type;
      if (type == "1") {
        this.view.il = true;
        this.ajaxGetImg();
      }
    } else {
      if (!this.view.sf) {
        _ajax_loop_able = true;
        this.ajaxGetImg();
      }
    }

    //*
    // this.view.il = false;
    // this.view.is = "5";
    //*/
  },
  destroyed() {
    _ajax_loop_able = false;
  },
};
export default w;
</script>
<style scoped>
.el-container {
  height: 100%;
}
.el-header,
.el-footer {
  text-align: center;
  line-height: 60px;
}

.el-main {
  height: calc(100% - 120px);
}

.footer {
  background-color: #151a28;
  color: #fff;
}

.el-carousel__item {
  height: 100%;
}

.bgi-wrap {
  height: 100%;
  text-align: center;
  overflow: hidden;
}

.bgil1 {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.bgil2 {
  height: 100%;
}

.bgi {
  height: 100%;
  margin: 0 -220px;
}

.lf {
  position: absolute;
  z-index: 10;
  top: 50%;
  right: 5%;
  height: 400px;
  width: 400px;
  margin-top: -200px;
  border-radius: 20px;
}

.lf-bg {
  height: 100%;
  width: 100%;
  background: #000;
  opacity: 0.4;
  border-radius: 20px;
}

.lf-fg {
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  background: transparent;
}

.lf-tr {
  position: absolute;
  top: 0;
  right: 0;
  height: 40px;
  width: 40px;
  z-index: 11;
}

.lf-tr-01 {
  height: 100%;
  width: 100%;
  background: url("../../assets/img/ewm.png");
  background-repeat: no-repeat;
  background-size: cover;
  border-top-right-radius: 20px;
  cursor: pointer;
}

.lf-tr-02 {
  height: 100%;
  width: 100%;
  background: url("../../assets/img/pc.png");
  background-repeat: no-repeat;
  background-size: cover;
  border-top-right-radius: 20px;
  cursor: pointer;
}

.lf-f {
  margin: auto;
  margin-top: 45px;
  text-align: center;
  width: 80%;
}

.lf-i {
  margin-top: 45px;
  text-align: center;
}

.lf-i-t {
  color: #fff;
  font-size: 24px;
  text-align: center;
  margin: 12px;
}

.login-panel {
  margin: auto;
  width: 320px;
}

.page-login {
  height: 100%;
  background-color: #f5f8fd;
}

.page-login .bg {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 10;
  /* background: url("../../assets/img/login-bg.png") no-repeat; */
  background-size: cover;
}

.page-login .main {
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
}

.page-login .footer {
  flex: 0 0 80px;
  font-size: 14px;
  color: #fff;
}

.page-login .footer > div {
  max-width: 1180px;
  margin: auto;
  /* border-top: 1px solid #fff; */
  /*color: #999;*/
  line-height: 24px;
}
/*page-home*/
.page-home {
  background-color: #f5f8fd;
}

.page-home .main {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.page-home .main * {
  box-sizing: border-box;
}

.page-home .layout-top {
  flex: 0 0 40px;
  background-color: #fcfcfc;
  color: #666;
  display: flex;
  line-height: 40px;
  /* rgba(0,21,41,.35) */
  border-bottom: 1px solid #ccc;
  transition: all 0.1s;
}

#div_sx {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
  background: hsla(0, 0%, 100%, 0.9);
  padding: 0;
  padding-top: 80px;

  cursor: pointer;
}

#div_f1,
#div_f2,
#div_f3 {
  display: none;
}

#btn_rz {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 30px;
  width: 120px;
  border-radius: 15px;
}

a {
  color: #0072ff;
  font-size: 15px;
}

.elipt-yzm {
  width: calc(100% - 110px) !important;
}

.btn-yzm {
  width: 110px !important;
}

.lf-f-t {
  color: #fff;
  font-size: 24px;
  text-align: center;
  margin: 12px;
  margin-bottom: 60px;
}
</style>
